export const availableShowingTimesMock = [
  {
    date: '2024-11-14',
    times: ['09:00', '13:00', '16:00'],
  },
  {
    date: '2024-11-15',
    times: ['09:00', '13:00'],
  },
  {
    date: '2024-11-22',
    times: ['11:00', '14:00', '16:00'],
  },
  {
    date: '2024-11-24',
    times: ['08:00', '12:00', '17:00'],
  },
  {
    date: '2024-11-27',
    times: ['09:00', '14:00'],
  },
  {
    date: '2024-11-29',
    times: ['10:00', '15:00'],
  },
  {
    date: '2024-11-30',
    times: ['09:00', '11:00', '16:00'],
  },
  {
    date: '2024-11-31',
    times: ['08:00', '13:00', '17:00'],
  },
];
